import React from 'react';

import { LocaleService } from '@sm360/widget-commons-core-services';

import 'login/components/Transaction/TransactionAction/TransactionFinancingState/TransactionFinancingState.scss';

const FinancingState = () => {
    return (
        <div className="confirm_financing--wrapper">
            <div className="confirm_financing--icon">
                <icon className="icon-Crochet" />
            </div>
            <div className="confirm_financing--content">
                <p className="confirm_financing--title is-bold">
                    {LocaleService.t('TRANSACTION_PROGRESSION.TRANSACTION_ACTION.FINANCE.ALREADY_COMPLETED.CONGRATS')}
                </p>
                <p className="confirm_financing--subtitle sr-text is-bold">
                    {LocaleService.t('TRANSACTION_PROGRESSION.TRANSACTION_ACTION.FINANCE.ALREADY_COMPLETED.TITLE')}
                </p>
                <p>
                    {LocaleService.t('TRANSACTION_PROGRESSION.TRANSACTION_ACTION.FINANCE.ALREADY_COMPLETED.SUBTITLE')}
                </p>
            </div>
        </div>
    );
};

FinancingState.displayName = 'FinancingState';

export default FinancingState;
